import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "../components/ErrorPage/ErrorPage";
import Home from "../page/Home";
import Main from "../layout/Main";
import Blog from "../page/Blog";
import OneSingleProject from "../page/project/OneSingleProject";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <Main />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
                path: "/home",
                element: <Home />,
            },
            {
                path: '/blog',
                element: <Blog></Blog>
            },
            {
                path: "/:id",
                element: <OneSingleProject />,
                loader: ({ params }) =>
                    fetch(`https://arifullah-cv-server.vercel.app/project/${params.id}`),
            },
        ],
    },


]);